import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LinksComponent } from './components/links/links.component';
import { FooterComponent } from './footer.component';

@NgModule({
  declarations: [FooterComponent, LinksComponent],
  imports: [CommonModule, RouterModule],
  exports: [FooterComponent],
})
export class FooterModule {}
